import React from 'react';
import PropTypes from 'prop-types';

import {
   ResultsCard,
   ResultRow,
   ResultsEmpty,
   ResultsFooter,
   Highlight,
} from '../styles';
import { MAX_RESULTS } from '../search';

const ICON_SIZE = 18;

const rangeShape = PropTypes.shape({
   start: PropTypes.number.isRequired,
   end: PropTypes.number.isRequired,
});

/**
 * Aplica o realce sobre o texto ORIGINAL, usando o intervalo já convertido
 * pelo `search.js` (a busca compara texto normalizado, sem acento — o
 * intervalo vem remapeado para os índices do texto com acento).
 */
function withHighlight(text, range) {
   if (!range) return text;

   return (
      <>
         {text.slice(0, range.start)}
         <Highlight>{text.slice(range.start, range.end)}</Highlight>
         {text.slice(range.end)}
      </>
   );
}

/**
 * Resultado da busca (§2.3): lista plana ordenada por relevância, com o caminho
 * `Módulo › Grupo` à direita e o trecho casado em destaque.
 *
 * Quando o casamento foi no nome do módulo (e não no rótulo), o realce aparece
 * no caminho — é o que explica por que o item está na lista.
 */
function SearchResults({ results, total, onNavigate }) {
   if (!results.length) {
      return (
         <ResultsCard>
            <ResultsEmpty>
               <h3>Nenhuma tela encontrada</h3>
               <p>Ajuste os termos da busca.</p>
            </ResultsEmpty>
         </ResultsCard>
      );
   }

   return (
      <ResultsCard>
         {results.map((item) => {
            const Icon = item.icon;

            return (
               <ResultRow
                  key={`${item.moduleId}-${item.to}`}
                  to={item.to}
                  onClick={() => onNavigate(item)}
               >
                  <span className="result-icon" aria-hidden="true">
                     {Icon ? <Icon size={ICON_SIZE} /> : null}
                  </span>
                  <span className="result-label">
                     {withHighlight(item.label, item.labelRange)}
                     {item.novo && <span className="sr-only"> (Novo)</span>}
                  </span>
                  <span className="result-path">
                     {withHighlight(item.moduleName, item.pathRange)}
                     {item.groupName ? ` › ${item.groupName}` : ''}
                  </span>
               </ResultRow>
            );
         })}

         {/* Sem corte silencioso: se houve truncamento, a tela informa. */}
         {total > results.length && (
            <ResultsFooter>
               Mostrando os {MAX_RESULTS} resultados mais relevantes de {total}.
               Refine a busca para ver os demais.
            </ResultsFooter>
         )}
      </ResultsCard>
   );
}

SearchResults.propTypes = {
   results: PropTypes.arrayOf(
      PropTypes.shape({
         to: PropTypes.string.isRequired,
         label: PropTypes.string.isRequired,
         moduleId: PropTypes.string.isRequired,
         moduleName: PropTypes.string.isRequired,
         groupName: PropTypes.string,
         labelRange: rangeShape,
         pathRange: rangeShape,
      })
   ).isRequired,
   total: PropTypes.number.isRequired,
   onNavigate: PropTypes.func.isRequired,
};

export default SearchResults;
